var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import GlobalStyles from '@mui/joy/GlobalStyles';
import Sheet from '@mui/joy/Sheet';
import IconButton from '@mui/joy/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { toggleSidebar } from '../../../utils';
export default function Header() {
    return (_jsxs(Sheet, __assign({ sx: {
            display: { xs: 'flex', md: 'none' },
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'fixed',
            top: 0,
            width: '100vw',
            height: 'var(--Header-height)',
            zIndex: 9995,
            p: 2,
            gap: 1,
            borderBottom: '1px solid',
            borderColor: 'background.level1',
            boxShadow: 'sm',
        } }, { children: [_jsx(GlobalStyles, { styles: function (theme) {
                    var _a;
                    return ({
                        ':root': (_a = {
                                '--Header-height': '52px'
                            },
                            _a[theme.breakpoints.up('md')] = {
                                '--Header-height': '0px',
                            },
                            _a),
                    });
                } }), _jsx(IconButton, __assign({ onClick: function () { return toggleSidebar(); }, variant: "outlined", color: "neutral", size: "sm" }, { children: _jsx(MenuIcon, {}) }))] })));
}
